import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a0e56da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand" }
const _hoisted_2 = { class: "controls" }

import { computed, ref } from 'vue';
import { Howler } from 'howler';
import { useAppState, useGameState } from '@/services/composition';
import { Role } from '@/services/states/AppStateMachine';
import AudioManager from "@/core/audio/AudioManager"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { send, state: appState } = useAppState()
const state = useGameState()

const sound = ref(null)

const theme = computed(() => {
  return appState.value.context.role === Role.Companion ? 'light' : 'dark'
})

const btnColor = computed(() => {
  return appState.value.context.role === Role.Companion ? 'dark-red' : 'light'
})

const toggleAudio = () => {
  const isMuted = Howler.volume() === 0

  if (isMuted) {
    sound.value?.play()
  } else {
    sound.value?.pause()
  }

  AudioManager.setMute(isMuted ? false : true)
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar", _unref(theme)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ui_icon, { name: "logo-brand" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ui_btn_icon, {
        ref_key: "sound",
        ref: sound,
        class: "btn-sound",
        name: "sound",
        variant: "secondary",
        color: _unref(btnColor),
        isLottie: true,
        onClick: toggleAudio
      }, null, 8, ["color"]),
      _createVNode(_component_ui_btn_icon, {
        class: "btn-pause",
        name: _unref(state).context.isPaused ? 'play' : 'pause',
        color: _unref(btnColor),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_TOGGLE_PAUSE')))
      }, null, 8, ["name", "color"])
    ])
  ], 2))
}
}

})